import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      logo: require('@/assets/plans/zcm.svg'),
      title: this.$t('billing.zcm_storage.title'),
      planType: planTypes.ZCM_STORAGE,
    };
  },

  created() {
    this.configDescription = this.$t('billing.zcm_storage.description', [this.basicConfig?.ZCMDefaultStorage || '10 GB'])
  }
};
